<app-doc-viewer
  title="Ogc filter"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/ogc-filter">
    <mat-grid-list cols="2" rowHeight="600px" gutterSize="16px">
      <mat-grid-tile>
        <igo-map-browser [map]="map" [view]="view">
          <div class="map-actions --vertical --bottom --right">
            <igo-zoom-button [map]="map" color="primary" />
          </div>
        </igo-map-browser>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="flex align-start h-100 w-100 overflow-y-auto">
          <igo-panel title="Layers">
            <igo-ogc-filterable-list
              [map]="map"
              [layers]="map.layerController.all"
            />
          </igo-panel>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </app-example-viewer>
</app-doc-viewer>
